import React, { Component } from "react";
import { withAuth } from "../Auth/WithAuth";
import { authenticatedFetch } from "../../utils/apiClient";

let isMounted = false;

export default withAuth(
  class CompoPageAdmin extends Component {
    constructor(props) {
      super(props);
      this.state = {
        composPage: {},
        title: "Konkurranser",
        games: [],
        editMode: false,
        updated: Date().toLocaleString()
      };

      this.getComposPage = this.getComposPage.bind(this);
      this.setEditMode = this.setEditMode.bind(this);
      this.handleChangeText = this.handleChangeText.bind(this);
      this.handleGameChange = this.handleGameChange.bind(this);
      this.addGame = this.addGame.bind(this);
      this.removeGame = this.removeGame.bind(this);
      this.moveGameUp = this.moveGameUp.bind(this);
      this.moveGameDown = this.moveGameDown.bind(this);
      this.saveComposPage = this.saveComposPage.bind(this);
      this.setUpdatedBy = this.setUpdatedBy.bind(this);
    }

    async componentDidMount() {
      isMounted = true;
      this.getComposPage();

      let updatedBy = this.props.auth.currentUser ? this.props.auth.currentUser.username : "Unknown";

      this.setState({
        composPage: Object.assign({}, this.state.composPage, {
          UpdatedBy: updatedBy
        })
      });
    }

    componentWillUnmount() {
      isMounted = false;
    }

    async getComposPage() {
      try {
        const response = await fetch("/api/pagedata/getComposPage", {
          method: "get",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            pragma: "no-cache",
            "cache-control": "no-cache"
          }
        });

        const data = await response.json();
        if (data && data.length > 0 && data[0]) {
          let games = data[0].games;

          // Migration: if no games array exists but old game1-5 structure exists, migrate it
          if (!games && (data[0].game1Title || data[0].game2Title || data[0].game3Title || data[0].game4Title || data[0].game5Title)) {
            games = this.migrateOldGameStructure(data[0]);
          }

          this.setState({
            composPage: data[0],
            title: data[0].title || "Konkurranser",
            games: games || this.getDefaultGames(),
            error: false
          });
        } else {
          // Fallback to default content if no database content exists
          this.setState({
            composPage: {
              composOpen: false,
              composOpenPost: "Gaming competitions are coming soon!",
              composClosedPost: "Competitions are currently closed."
            },
            title: "Konkurranser",
            games: this.getDefaultGames(),
            error: false
          });
        }
      } catch (err) {
        console.log(err);
        this.setState({ error: true });
      }
    }

    migrateOldGameStructure(oldData) {
      const games = [];

      for (let i = 1; i <= 5; i++) {
        const title = oldData[`game${i}Title`];
        const content = oldData[`game${i}Post`];
        const active = oldData[`game${i}Active`];

        if (title) {
          games.push({
            id: `game_${i}`,
            title: title,
            content: content || "",
            active: active || false,
            order: i
          });
        }
      }

      return games;
    }

    getDefaultGames() {
      return [
        {
          id: "game_1",
          title: "Counter-Strike 2",
          content: "Classic competitive FPS tournament.",
          active: false,
          order: 1
        },
        {
          id: "game_2",
          title: "League of Legends",
          content: "5v5 MOBA championship.",
          active: false,
          order: 2
        },
        {
          id: "game_3",
          title: "Rocket League",
          content: "Car soccer tournament.",
          active: false,
          order: 3
        }
      ];
    }

    async setEditMode() {
      if (this.state.editMode === false) {
        this.setState({ editMode: true });
      } else {
        this.setState({ editMode: false });
      }
      await this.getComposPage();
    }

    async setUpdatedBy() {
      let updatedBy = this.props.auth.currentUser ? this.props.auth.currentUser.username : "Unknown";

      await this.setState({
        composPage: Object.assign({}, this.state.composPage, {
          UpdatedBy: updatedBy
        })
      });
    }

    async saveComposPage() {
      await this.setUpdatedBy();

      const dataToSave = {
        ...this.state.composPage,
        title: this.state.title,
        games: this.state.games
      };

      try {
        await authenticatedFetch("/api/admin/updateComposPage", {
          method: "PUT",
          body: JSON.stringify(dataToSave),
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json"
          }
        });

        // Clear cache
        await fetch("/api/pagedata/clearComposPageCache", {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json"
          }
        });

      } catch (err) {
        console.log(err);
      } finally {
        this.setState({ editMode: false });
        window.scrollTo(0, 0);
      }
    }

    handleChangeText(event) {
      const { name, value } = event.target;

      if (name === "title") {
        this.setState({
          title: value,
          composPage: Object.assign({}, this.state.composPage, {
            title: value
          })
        });
      } else if (name === "composOpen") {
        this.setState({
          composPage: Object.assign({}, this.state.composPage, {
            composOpen: event.target.checked
          })
        });
      } else if (name === "composOpenPost") {
        this.setState({
          composPage: Object.assign({}, this.state.composPage, {
            composOpenPost: value
          })
        });
      } else if (name === "composClosedPost") {
        this.setState({
          composPage: Object.assign({}, this.state.composPage, {
            composClosedPost: value
          })
        });
      }
    }

    handleGameChange(gameId, field, value) {
      const updatedGames = this.state.games.map(game => {
        if (game.id === gameId) {
          return { ...game, [field]: value };
        }
        return game;
      });
      this.setState({ games: updatedGames });
    }

    addGame() {
      const newGame = {
        id: `game_${Date.now()}`,
        title: "New Game",
        content: "<p>Game description...</p>",
        active: false,
        order: this.state.games.length + 1
      };
      this.setState({ games: [...this.state.games, newGame] });
    }

    removeGame(gameId) {
      const game = this.state.games.find(g => g.id === gameId);
      const gameTitle = game ? game.title : "spillet";
      if (window.confirm(`Er du sikker på at du vil slette ${gameTitle}?`)) {
        const updatedGames = this.state.games.filter(game => game.id !== gameId);
        this.setState({ games: updatedGames });
      }
    }

    moveGameUp(gameId) {
      const games = [...this.state.games];
      const index = games.findIndex(game => game.id === gameId);
      if (index > 0) {
        const temp = games[index].order;
        games[index].order = games[index - 1].order;
        games[index - 1].order = temp;
        this.setState({ games: games });
      }
    }

    moveGameDown(gameId) {
      const games = [...this.state.games];
      const index = games.findIndex(game => game.id === gameId);
      if (index < games.length - 1) {
        const temp = games[index].order;
        games[index].order = games[index + 1].order;
        games[index + 1].order = temp;
        this.setState({ games: games });
      }
    }

    render() {
      if (this.props.authenticated === null) return null;

      return (
        <div className="SignupList">
          <h1>Composiden</h1>
          <button
            className={
              "btn btno edit  " +
              (this.state.editMode ? "btn-info" : "btn-danger")
            }
            onClick={this.setEditMode}
          >
            {this.state.editMode ? "Lås" : "Rediger"}
          </button>
          <button
            className="btn btno btn-success edit  "
            onClick={() => this.getComposPage()}
          >
            Refresh
          </button>

          {this.state.editMode && (
            <button
              className="btn btno btn-primary edit"
              onClick={this.saveComposPage}
              style={{ marginLeft: "10px", cursor: "pointer" }}
            >
              Lagre endringer
            </button>
          )}

          <hr />

          {this.state.editMode ? (
            <div style={{ marginTop: "20px" }}>
              <div style={{ display: "flex", gap: "30px", marginBottom: "30px" }}>
                <div style={{ flex: "1" }}>
                  <h3>Rediger innhold:</h3>
                  <div className="form-group">
                    <label htmlFor="title"><strong>Sidetittel:</strong></label>
                    <input
                      type="text"
                      className="form-control"
                      id="title"
                      name="title"
                      value={this.state.title}
                      onChange={this.handleChangeText}
                      style={{ marginBottom: "20px" }}
                    />
                  </div>

                  <div className="form-group">
                    <label><strong>Konkurranser åpen:</strong></label>
                    <input
                      type="checkbox"
                      name="composOpen"
                      checked={this.state.composPage.composOpen || false}
                      onChange={this.handleChangeText}
                      style={{ marginLeft: "10px" }}
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="composOpenPost"><strong>Konkurranser åpen tekst:</strong></label>
                    <textarea
                      className="form-control"
                      id="composOpenPost"
                      name="composOpenPost"
                      value={this.state.composPage.composOpenPost || ""}
                      onChange={this.handleChangeText}
                      rows="4"
                      style={{ marginBottom: "20px" }}
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="composClosedPost"><strong>Konkurranser stengt tekst:</strong></label>
                    <textarea
                      className="form-control"
                      id="composClosedPost"
                      name="composClosedPost"
                      value={this.state.composPage.composClosedPost || ""}
                      onChange={this.handleChangeText}
                      rows="4"
                      style={{ marginBottom: "20px" }}
                    />
                  </div>
                </div>

                <div style={{ flex: "1" }}>
                  <h3>Forhåndsvisning:</h3>

                  <div style={{ border: "1px solid #495057", padding: "20px", marginBottom: "20px", backgroundColor: "#1a1d29", color: "white", borderRadius: "4px" }}>
                    <h4>Sidetittel</h4>
                    <div dangerouslySetInnerHTML={{ __html: this.state.title }} />
                  </div>

                  <div style={{ border: "1px solid #495057", padding: "20px", marginBottom: "20px", backgroundColor: "#1a1d29", color: "white", borderRadius: "4px" }}>
                    <h4>Konkurranser åpen: {this.state.composPage.composOpen ? "Ja" : "Nei"}</h4>
                    <div dangerouslySetInnerHTML={{ __html: this.state.composPage.composOpen ? this.state.composPage.composOpenPost : this.state.composPage.composClosedPost }} />
                  </div>
                </div>
              </div>

              <hr />

              <div style={{ marginBottom: "20px" }}>
                <h3>Spill</h3>
                <button
                  type="button"
                  className="btn btn-success"
                  onClick={this.addGame}
                  style={{ marginBottom: "20px", cursor: "pointer" }}
                >
                  Legg til spill
                </button>
              </div>

              {this.state.games
                .sort((a, b) => a.order - b.order)
                .map((game, index) => (
                  <div key={game.id} style={{ display: "flex", gap: "30px", marginBottom: "30px" }}>
                    <div style={{ flex: "1", border: "1px solid #495057", padding: "20px", backgroundColor: "#1a1d29", color: "white", borderRadius: "4px" }}>
                      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "10px" }}>
                        <h4>Spill {index + 1}</h4>
                        <div>
                          <button
                            type="button"
                            className="btn btn-sm btn-secondary"
                            onClick={() => this.moveGameUp(game.id)}
                            disabled={index === 0}
                            style={{ marginRight: "5px", cursor: "pointer" }}
                          >
                            ↑
                          </button>
                          <button
                            type="button"
                            className="btn btn-sm btn-secondary"
                            onClick={() => this.moveGameDown(game.id)}
                            disabled={index === this.state.games.length - 1}
                            style={{ marginRight: "5px", cursor: "pointer" }}
                          >
                            ↓
                          </button>
                          <button
                            type="button"
                            className="btn btn-sm btn-danger"
                            onClick={() => this.removeGame(game.id)}
                            style={{ cursor: "pointer" }}
                          >
                            Slett
                          </button>
                        </div>
                      </div>

                      <div className="form-group">
                        <label><strong>Aktiv:</strong></label>
                        <input
                          type="checkbox"
                          checked={game.active}
                          onChange={(e) => this.handleGameChange(game.id, 'active', e.target.checked)}
                          style={{ marginLeft: "10px", marginBottom: "10px" }}
                        />
                      </div>

                      <div className="form-group">
                        <label><strong>Tittel:</strong></label>
                        <input
                          type="text"
                          className="form-control"
                          value={game.title}
                          onChange={(e) => this.handleGameChange(game.id, 'title', e.target.value)}
                          style={{ marginBottom: "10px" }}
                        />
                      </div>

                      <div className="form-group">
                        <label><strong>Innhold:</strong></label>
                        <textarea
                          className="form-control"
                          value={game.content}
                          onChange={(e) => this.handleGameChange(game.id, 'content', e.target.value)}
                          rows="8"
                        />
                      </div>
                    </div>

                    <div style={{ flex: "1", border: "1px solid #495057", padding: "20px", backgroundColor: "#1a1d29", color: "white", borderRadius: "4px" }}>
                      <h4>{game.title} {game.active ? "(Aktiv)" : "(Inaktiv)"}</h4>
                      <div dangerouslySetInnerHTML={{ __html: game.content }} />
                    </div>
                  </div>
                ))}

            </div>
          ) : (
            <div style={{ marginTop: "20px", maxWidth: "800px", margin: "20px auto" }}>
              <h3>Forhåndsvisning:</h3>

              <div style={{ border: "1px solid #495057", padding: "20px", marginBottom: "20px", backgroundColor: "#1a1d29", color: "white", borderRadius: "4px" }}>
                <h4>Sidetittel</h4>
                <div dangerouslySetInnerHTML={{ __html: this.state.title }} />
              </div>

              <div style={{ border: "1px solid #495057", padding: "20px", marginBottom: "20px", backgroundColor: "#1a1d29", color: "white", borderRadius: "4px" }}>
                <h4>Konkurranser åpen: {this.state.composPage.composOpen ? "Ja" : "Nei"}</h4>
                <div dangerouslySetInnerHTML={{ __html: this.state.composPage.composOpen ? this.state.composPage.composOpenPost : this.state.composPage.composClosedPost }} />
              </div>

              {this.state.games
                .sort((a, b) => a.order - b.order)
                .map((game, index) => (
                  <div key={game.id} style={{ border: "1px solid #495057", padding: "20px", marginBottom: "20px", backgroundColor: "#1a1d29", color: "white", borderRadius: "4px" }}>
                    <h4>{game.title} {game.active ? "(Aktiv)" : "(Inaktiv)"}</h4>
                    <div dangerouslySetInnerHTML={{ __html: game.content }} />
                  </div>
                ))}
            </div>
          )}
        </div>
      );
    }
  }
);


// WEBPACK FOOTER //
// ./src/Components/Admin/CompoPageAdmin.js